import type { PatientProfile } from '@/entities/user-info';
import { Table, TableBody, TableCell, TableRow } from '@/shared/ui/shadcn/table';

export interface PatientProfilePanelProps {
  profile: PatientProfile;
}

export function PatientProfilePanel({ profile }: PatientProfilePanelProps) {
  return (
    <section aria-label="Patient profile" className="flex flex-col gap-3">
      <h2 className="text-lg font-medium tracking-tight text-foreground">{profile.heading}</h2>
      <Table>
        <TableBody>
          {profile.entries.map((entry) => (
            <TableRow key={entry.field} className="border-b-0">
              <TableCell className="w-[180px] whitespace-nowrap font-medium text-muted-foreground">
                {entry.label}
              </TableCell>
              <TableCell className="whitespace-normal text-foreground">{entry.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </section>
  );
}
